module.exports = __webpack_public_path__ + "static/web-app-xs-4d2a366619105f95efdebe3722c6cb5b.png";